export default {
    custom_geoip: 'Geo IP',
    eexportd_conf: 'Exports',
    pcap_config: 'Packet Capture',
    data_tags: 'Data Tuning',
    file_hash: 'File Hash',
    system_config: 'Configuration',
    sensor_upgrade: 'Upgrade',
    suricata_rules: 'Suricata Rules',
    suricata_config: 'Suricata Vars',
    bro_ti: 'Zeek Scripts',
    zeek_indicators: 'Threat Intelligence',
};
